import { GradingScheme } from './grading-scheme.model';

export class GradingSchemeCommand {
    grading_scheme: {
        id: string;
    };

    constructor(model: GradingScheme) {
        this.grading_scheme = {
            id: model.id,
        };
    }
}
